import { MeterFieldProps } from "../../../types/salesDocuments.types";
import { useMeterContext } from "../meterContext";

export const UpliftRateComponent: React.FC<MeterFieldProps> = ({ meter, hidden }) => {
  const ctx = useMeterContext();
  if (hidden) return null;
  return (
    <div className="sales-doc-field mb-3">
      <hr className="sales-doc-divider" />
      <div className="mb-3">
        <label htmlFor={`meter-${meter.id.toString()}-standing-charge`}>
          Standing Charge (p/day)
        </label>
        <input
          type="number"
          min="0"
          step="0.00001"
          className="form-control"
          id={`meter-${meter.id.toString()}-standing-charge`}
          value={ctx.standingCharge}
          onChange={(e) => {
            ctx.setStandingCharge(e.target.value);
          }}
        />
      </div>
      <div className="mb-3">
        <label htmlFor={`meter-${meter.id.toString()}-uplift-rate`}>Uplift Rate (p/kWh)</label>
        <input
          type="number"
          min="0"
          step="0.00001"
          className="form-control"
          id={`meter-${meter.id.toString()}-uplift-rate`}
          value={ctx.upliftRate}
          onChange={(e) => {
            ctx.setUpliftRate(e.target.value);
          }}
        />
      </div>
      <div className="mb-3">
        <label htmlFor={`meter-${meter.id.toString()}-sc-uplift-rate`}>
          SC Uplift Rate (p/day)
        </label>
        <input
          type="number"
          min="0"
          step="0.00001"
          className="form-control"
          id={`meter-${meter.id.toString()}-sc-uplift-rate`}
          value={ctx.scUpliftRate}
          onChange={(e) => {
            ctx.setScUpliftRate(e.target.value);
          }}
        />
      </div>
    </div>
  );
};
